<template>
  <v-dialog
    :value="enableDialog"
    persistent
    scrollable
    width="1600"
    @keydown.esc="closeButtonClickEvent"
  >
    <validation-observer
      ref="completionReportValidator"
    >
      <v-card dense>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>
            {{ type === 'Accepts' ? '運搬終了報告兼本登録（個別登録）' : '運搬終了報告（個別登録）' }}
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text
          v-if="manifests"
          style="max-height: 70vh;overflow-y: scroll"
          class="mt-0 py-1"
        >
          <v-card
            v-for="(manifest, index) in manifests"
            :class="{ 'excluded-manifest': !manifest.target_for_registration, 'pt-2': index === 0 }"
            :key="manifest.id"
            flat
          >
            <v-card-text class="px-2 py-0">
              <v-row dense>
                <!-- マニフェスト情報 -->
                <v-col
                  cols="12"
                  md="3"
                >
                  <manifest
                    caller-type="completion_report"
                    :manifest.sync="manifests[index]"
                    @targetOfRegistrationChange="targetOfRegistrationChangeCallback"
                  />
                </v-col>
                <!-- /マニフェスト情報 -->

                <!-- 基本情報 -->
                <v-col
                  v-if="!['self_emission', 'proxy_request'].includes(manifest.order_type)"
                  cols="12"
                  md="5"
                >
                  <completion-basic
                    caller-type="completion_report"
                    :drivers="drivers"
                    :manifest.sync="manifests[index]"
                    :users="users"
                    :vehicles="vehicles"
                    @copyField="copyTarget"
                    @copyFullField="copyAllField"
                  />
                </v-col>
                <!-- /基本情報 -->

                <!-- 数量情報 -->
                <v-col
                  v-if="!['self_emission', 'proxy_request'].includes(manifest.order_type)"
                  cols="12"
                  md="4"
                >
                  <completion-quantity
                    :manifest.sync="manifests[index]"
                    :process-type="type"
                    :quantity-units="quantityUnits"
                    :valuables-quantity-units="valuablesQuantityUnits"
                    caller-type="completion_report"
                    @copyField="copyTarget"
                    @copyFullField="copyAllField"
                    @sectionChange="sectionChangeCallback"
                  />
                </v-col>
                <!-- /数量情報 -->

                <!-- 排出持込 数量情報 -->
                <v-col
                  v-if="['self_emission', 'proxy_request'].includes(manifest.order_type)"
                  cols="12"
                  md="5"
                >
                  <self-emission-quantity
                    caller-type="completion_report"
                    :manifest.sync="manifests[index]"
                    :process-type="manifest.display_type"
                    :quantity-units="quantityUnits"
                  />
                </v-col>
                <!-- /排出持込 数量情報 -->

              </v-row>
            </v-card-text>
            <v-divider v-if="index < manifests.length - 1" class="my-2" />
          </v-card>
        </v-card-text>
        <v-divider class="mb-0" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="manifests===null"
            class="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import Manifest from "./contents/_Manifest.vue";
import CompletionBasic from "./contents/_CompletionBasic.vue";
import CompletionQuantity from "./contents/_CompletionQuantity.vue";
import SelfEmissionQuantity from "./contents/_SelfEmissionQuantity.vue";

export default {
  name: 'CompletionReport',
  components: {
    Manifest,
    CompletionBasic,
    CompletionQuantity,
    SelfEmissionQuantity,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestIds: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => null,
    },
    sortType: {
      type: String,
      default: () => null,
    },
    orderIds: {
      type: Array,
      default: () => [],
    },
    driverScheduleId: {
      type: Number || null,
      default: () => null
    }
  },
  data() {
    return {
      manifests: null,
      users: [],
      drivers: [],
      vehicles: [],
      quantityUnits: [],
      valuablesQuantityUnits: [],
      fromOrder: false,
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.manifests = null
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestCompletionReport', {
      fetchManifests: 'show',
      updateManifests: 'update',
    }),
    ...mapActions('DriverOrderCompletionReport', {
      fetchManifestsByOrder: 'show',
      updateManifestsByOrder: 'update',
    }),
    ...mapActions('DriverMasterSearchUser', {
      fetchUsers: 'index',
    }),
    ...mapActions('DriverMasterSearchDriver', {
      fetchDrivers: 'only_text',
    }),
    ...mapActions('DriverMasterSearchVehicle', {
      fetchVehicles: 'search',
    }),
    ...mapActions('DriverMasterSearchQuantityUnit', {
      fetchQuantityUnits: 'index',
    }),
    ...mapActions('DriverManifestManifestDetail',{
      fetchDetail: 'show',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      const $self = this;
      this.$refs.completionReportValidator.validate().then((result) => {
        if (result) {
          setTimeout($self.registerInformation, 500);
        }
      })
    },
    /**
     * 基本情報
     * 区分変更 コールバック
     *
     * 渡されたマニフェストIDを持つマニフェストの区間で表示内容を更新する.
     * @param manifest_id { Number } マニフェストID
     * @param section { Number } 区間番号
     */
    sectionChangeCallback (manifest_id, section) {
      const currentManifest = this.manifests.find((manifest) => manifest.id === manifest_id);
      this.fetchDetail({ id: manifest_id, section_no: section, process_type: currentManifest.display_type }).then((content) => {
        if (['self_emission', 'proxy_request'].includes(currentManifest.order_type)) {
          currentManifest.quantity = content.quantity
          currentManifest.quantity_unit_id = content.quantity_unit_id
        } else {
          currentManifest.report_reporter_name = content.report_reporter_name
          currentManifest.report_transport_completed_date = content.report_transport_completed_date
          currentManifest.report_transport_user_name = content.report_transport_user_name
          currentManifest.report_vehicle_number = content.report_vehicle_number
          currentManifest.use_report_transport_quantity = content.use_report_transport_quantity
          currentManifest.report_transport_quantity = content.report_transport_quantity
          currentManifest.report_transport_quantity_unit_id = content.report_transport_quantity_unit_id
          currentManifest.report_valuables_collecting_quantity = content.report_valuables_collecting_quantity
          currentManifest.report_valuables_collecting_quantity_unit_id = content.report_valuables_collecting_quantity_unit_id
          currentManifest.report_note = content.report_note
        }
        currentManifest.updated_at = content.updated_at
      });
    },
    /**
     * 基本情報
     * 登録対象チェックボックス変更 コールバック
     *
     * 同一オーダーIDを持つオブジェクトを検索し存在する場合は更新する.
     * @param order_id
     * @param checkable
     */
    targetOfRegistrationChangeCallback(order_id, checkable) {
      for (const manifest of this.manifests) {
        if (manifest.order_id === order_id) {
          manifest.target_for_registration = checkable;
        }
      }
    },
    /**
     * リクエスト送信
     */
    registerInformation () {

      // チェック付きだけを抽出
      const targetManifests = this.manifests.filter(manifest => manifest.target_for_registration);

      if (this.manifests.length > 0 && targetManifests.length > 0) {
        const mixedOrder = this.driverScheduleId != null;
        /* 送信対象はチェックがOnのみ */
        let params = { manifests: targetManifests, type: this.type }
        if (this.type === "Managements") {
          this.updateManifests({params: params}).then(() => {
            this.$emit('registerEvent')
          })
        } else {
          params['order_ids'] = this.orderIds
          params['type'] = this.type
          params['mixed_order'] = mixedOrder
          this.updateManifestsByOrder({params: params}).then(() => {
            this.$emit('registerEvent')
          })
        }
      }
    },
    setVariable () {
      this.$nextTick(() => this.$refs.completionReportValidator.reset())
      this.fetchUsers({without_invisible: true}).then((content) => { this.users = content.users })
      this.fetchDrivers({without_invisible: true}).then((content) => { this.drivers = content })
      this.fetchVehicles({ registered_number: true}).then((content) => { this.vehicles = content.vehicles })

      let params = { manifest_ids: this.manifestIds, sort_type: this.sortType }
      if (this.type === "Managements") {
        this.fetchManifests({ params: params }).then((content) => {
          this.manifests = content.manifests
        })
      } else {
        /** 受注発注の場合はorder単位でのマニフェスト絞込が必要 */
        params["order_ids"] = this.orderIds
        params['type'] = this.type
        params['driver_schedule_id'] = this.driverScheduleId
        this.fetchManifestsByOrder({ params: params }).then((content) => {
          this.manifests = content.manifests
        })
      }
      /**
       * 数量単位を展開
       * 有価物の数量単位は「個・台」は不要なのでコードで落とす
       */
      this.fetchQuantityUnits().then((content) => {
        this.quantityUnits = content.quantity_units
        this.valuablesQuantityUnits = content.quantity_units.filter(v => v.code !== '5')
      })
    },
    /**
     * 各項目複写ボタンクリックイベントのコールバック
     * @param column { String }
     * @param value { String, Number }
     */
    copyTarget (column, value) {

      /*
        それぞれの項目の複写ボタンですが、
          ①複写先が入力されている状態で、
          ②複写元が空白の場合、
          ③複写ボタンをクリックした時に
          ④複写先を上書きしない
          ようお願いしてよろしいでしょうか？
       */

      if (this.isBlank(value)) {
        return;
      }

      for (const manifest of this.manifests) {
        if (manifest.order_type && !['collection', 'general'].includes(manifest.order_type)) {
          continue;
        }
        if (column === 'report_reporter_name') {
            manifest.report_reporter_name = value
        } else if (column === 'report_transport_completed_date') {
            manifest.report_transport_completed_date = value
        } else if (column === 'report_transport_user_name') {
            manifest.report_transport_user_name = value
        } else if (column === 'report_vehicle_number') {
            manifest.report_vehicle_number = value
        } else if (column === 'report_transport_quantity') {
          manifest.report_transport_quantity = value
        } else if (column === 'report_transport_quantity_unit_id') {
          manifest.report_transport_quantity_unit_id = value
        } else if (column === 'report_valuables_collecting_quantity') {
          manifest.report_valuables_collecting_quantity = value
        } else if (column === 'report_valuables_collecting_quantity_unit_id') {
          manifest.report_valuables_collecting_quantity_unit_id = value
        } else if (column === 'report_note') {
          manifest.report_note = value
        }
      }
    },
    copyAllField (value) {
      for (const manifest of this.manifests) {
        if (manifest.order_type && !['collection', 'general'].includes(manifest.order_type)) {
          continue;
        }

        /* 報告担当者 */
        if (this.isNotBlank(value.report_reporter_name)) {
          manifest.report_reporter_name = value.report_reporter_name
        }

        /* 運搬終了日 */
        if (this.isNotBlank(value.report_transport_completed_date)) {
          manifest.report_transport_completed_date = value.report_transport_completed_date
        }

        /* 運搬担当者 */
        if (this.isNotBlank(value.report_transport_user_name)) {
          manifest.report_transport_user_name = value.report_transport_user_name
        }

        /* 車両番号 */
        if (this.isNotBlank(value.report_vehicle_number)) {
          manifest.report_vehicle_number = value.report_vehicle_number
        }

        /* 運搬備考 */
        if (this.isNotBlank(value.report_note)) {
          manifest.report_note = value.report_note
        }

        // /* 運搬量 */
        // if (value.report_transport_quantity !== null && value.report_transport_quantity !== "") {
        //   manifest.report_transport_quantity = value.report_transport_quantity
        // }
        //
        // /* 運搬量の単位 */
        // if (value.report_transport_quantity_unit_id !== null && value.report_transport_quantity_unit_id !== "") {
        //   manifest.report_transport_quantity_unit_id = value.report_transport_quantity_unit_id
        // }
        //
        // /* 有価物拾集量 */
        // if (value.report_valuables_collecting_quantity != null && value.report_valuables_collecting_quantity !== "") {
        //   manifest.report_valuables_collecting_quantity = value.report_valuables_collecting_quantity
        // }
        //
        // /* 有価物拾集量の単位 */
        // if (value.report_valuables_collecting_quantity_unit_id !== null && value.report_valuables_collecting_quantity_unit_id !== "") {
        //   manifest.report_valuables_collecting_quantity_unit_id = value.report_valuables_collecting_quantity_unit_id
        // }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.excluded-manifest {
  background-color: #E0E0E0 !important;;
}
</style>
